import { ReactComponent as ItemDoneIcon } from 'assets/icons/itemDone.svg';
import clsx from 'clsx';

import type IStepItem from './interfaces/IStepItem';

import styles from './sass/StepItem.module.scss';

function StepItem({
  title, step, disabled, done,
}: IStepItem) {
  return (
    <div className={clsx(styles.root, { [styles.disabled]: disabled })}>
      {done ? <ItemDoneIcon className={styles.done} /> : <span className={styles.step}>{step}</span>}
      <span className={styles.title}>{title}</span>
    </div>
  );
}

export default StepItem;
